import { useSelector } from 'react-redux';
import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom";

import { getLanguage } from "../../tools/Dictionary";
import { getNavigationAvailable } from "../../slices/navigationSlice";


import { MdErrorOutline, MdVerified, MdPerson, MdEast, MdAdminPanelSettings, MdSettings, MdHardware, MdPeople, MdArrowBack,
  MdAccountTree, MdFilePresent, MdDescription, MdOutlineHistoryEdu, MdInventory
 } from "react-icons/md";
import {  } from "react-icons/md";
import "./ListMenu.css";



const ListMenu = (props) =>
{

  //Props
  //const IsDesktop = props.isDesktop;

  //Navigate
  const Navigate = useNavigate();

  //Redux
  const AvailNavigation = useSelector(getNavigationAvailable);


  //Variable
  const listIcon = {
    "Trouble": <MdErrorOutline />,
    "Warranty": <MdVerified />,
    "Contact": <MdPerson />,
    "Admin": <MdAdminPanelSettings />,
    "Setting": <MdSettings />,
    "Ad_Product": <MdInventory />, 
    "Ad_Trouble": <MdErrorOutline />,
    "Ad_User": <MdPeople />,
    "Ad_Return": <MdArrowBack />,
    "Tr_Process": <MdAccountTree />,
    "Tr_File": <MdFilePresent />,
    "Tr_Report": <MdDescription />,
    "Tr_Log": <MdOutlineHistoryEdu />,
    "Tr_Return": <MdArrowBack />,
    "Pr_Product": <MdHardware />,
    "Pr_File": <MdFilePresent />,
    "Pr_Return": <MdArrowBack />
  }



  return (
    <div className="listmenu_cont"> 
      {AvailNavigation.filter(n => (n.isChildren || n.isReturn)).map((n, index) => (
        <motion.div
          key={index}
          variants={{ hidden: { opacity: 0, y: 20 * (index + 1) }, show: { opacity: 1, y: 0 }, exit: { opacity: 0 } }}
          initial="hidden"
          animate="show"
          className="listmenu_cont_item"
          onClick={() => Navigate(n.url)}
        >
          <div className="listmenu_cont_item_icon">
            {listIcon[n.code] || <MdEast />}
          </div>
          <div className='listmenu_cont_item_text'>
            {n.label[getLanguage().code] || n.label["EN"] || ""}
          </div>
        </motion.div>
      ))}
    </div>
  )

};

export default ListMenu;